const renderItem = (context) => (Component, key) =>
  (
    <Component
      key={key}
      {...context}
    />
  );

export default renderItem;
